"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
var _jsxFileName = "src/icons/Braking.js";
var _react = require("react");
var _react2 = _interopRequireDefault(_react);
function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}
var Braking = function Braking(props) {
  return _react2.default.createElement("svg", Object.assign({
    className: "line-icon",
    viewBox: "0 0 197.5 197.5"
  }, props, {
    __source: {
      fileName: _jsxFileName,
      lineNumber: 4
    },
    __self: undefined
  }), _react2.default.createElement("title", {
    __source: {
      fileName: _jsxFileName,
      lineNumber: 5
    },
    __self: undefined
  }, "Braking Icon"), _react2.default.createElement("g", {
    className: "brake-pedal",
    __source: {
      fileName: _jsxFileName,
      lineNumber: 6
    },
    __self: undefined
  }, _react2.default.createElement("path", {
    d: "M158.08 96.62l-44.55-32.1-7.02 9.74 18.13 13.08-20.77 28.83-60.24-44.62-7.15 9.65 60.36 44.71-.04.06 9.74 7.02 27.85-38.63 16.67 12.01 7.02-9.75z",
    __source: {
      fileName: _jsxFileName,
      lineNumber: 7
    },
    __self: undefined
  }), _react2.default.createElement("path", {
    d: "M98.75 0a98.75 98.75 0 1 0 98.75 98.75A98.75 98.75 0 0 0 98.75 0zm0 186.3a87.56 87.56 0 1 1 87.55-87.57 87.56 87.56 0 0 1-87.55 87.56z",
    className: "circle",
    __source: {
      fileName: _jsxFileName,
      lineNumber: 8
    },
    __self: undefined
  })));
};
exports.default = Braking;